import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full gap-4" }
const _hoisted_2 = { class: "font-semibold" }

import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import {Button, buttonVariants} from "@/components/ui/button";
import {cn, loggedUser} from "@/utils/utils";
import {Icon} from "@iconify/vue";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Profile',
  setup(__props) {

const user: any = loggedUser.getLoggedUserFromStorage();

const nameFirstLetter = user.name.substring(0, 1);
const surnameFirstLetter = user.surname.substring(0, 1);

async function logout() {
  localStorage.removeItem('user');
  await router.push({name: 'signin'})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Button), {
      variant: "ghost",
      class: "relative h-8 w-full rounded-full p-0 justify-start cursor-default",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'dashboard' })), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Avatar), { class: "h-8 w-8 mr-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(AvatarFallback), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(nameFirstLetter)) + _toDisplayString(_unref(surnameFirstLetter)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(user).name) + " " + _toDisplayString(_unref(user).surname), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      onClick: _withModifiers(logout, ["prevent"]),
      class: _normalizeClass(["w-2/12 justify-end hover:cursor-pointer", _unref(cn)(
            _unref(buttonVariants)({ variant: 'ghost', size: 'sm' }),
            'dark:text-white dark:hover:bg-muted dark:hover:text-white',
            'justify-start w-full',
          )])
    }, [
      _createVNode(_unref(Icon), {
        icon: "lucide:log-out",
        class: "mr-2 size-4"
      })
    ], 2)
  ]))
}
}

})